<template>
  <div>
    <div class="wap1">
      <div class="wap1-content">
        <img src="../../assets/images/public/logo.png" alt="" />
        <p>
          {{ aboutKELK.contentOne }}
        </p>
      </div>
    </div>
    <div class="wap2">
      <div class="left-content"></div>
      <div class="right-content">
        <div v-html="$convertPxToRem(aboutKELK.contentTwo)"></div>
      </div>
    </div>
    <div class="wap3">
      <div class="wap3-content">
        <img :src="aboutPage.about60thImg" alt="" />
        <div class="main-content">
          <div v-html="$convertPxToRem(aboutKELK.contentThree)"></div>
        </div>
        <hr width="1200px" size="1" color="#ddd" />
        <!-- <div class="main-content">
          <p style="margin-top: 50px">
            {{ aboutKELK.contentSix }}
          </p>
        </div> -->
        <div class="other--content" style="text-align: center;">
          {{ aboutKELK.contentSix }}
          <!-- <div class="box">
            <p class="title">{{ aboutKELK.team.title }}</p>
            <img src="../../assets/images/about/adouticon1.png" alt="" />
            <p v-html="aboutKELK.team.content"></p>
          </div>
          <div class="box">
            <p class="title">{{ aboutKELK.Base.title }}</p>
            <img src="../../assets/images/about/adouticon2.png" alt="" />
            <p>
              {{ aboutKELK.Base.content }}
            </p>
          </div>
          <div class="box">
            <p class="title">{{ aboutKELK.sales.title }}</p>
            <img src="../../assets/images/about/adouticon3.png" alt="" />
            <p>
              {{ aboutKELK.sales.content }}
            </p>
          </div> -->
        </div>
        <custom-video style="margin-top: 50px;width: 1000px;" :url="dataInfo ? dataInfo.files : ''"></custom-video>
      </div>
    </div>
  </div>
</template>


<script>

import { mapGetters } from "vuex"
import { getArticleList } from "@/utils/http.js";

export default {
  data() {
    return {
      dataInfo: null
    }
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    aboutPage() {
      return this.currentLang.config.aboutPage
    },
    aboutKELK() {
      return this.currentLang.config.aboutPage.aboutKELK
    }
  },

  created() {
    this.fetchVideo()
  },

  methods: {
    
    fetchVideo() {
      getArticleList({
        cate_id: 96
      }).then(res => {
        if (res.code === 1) {
          this.dataInfo = res.data.list && res.data.list.length > 0 ? res.data.list[0] : null;
        }
      });
    }
  }
}

</script>



<style lang="scss" scoped>
.wap1 {
  padding-top: 70px;
  padding-bottom: 70px;
  text-align: justify;

  .wap1-content {
    width: 1000px;
    margin: 0 auto 0;
    text-align: justify;
    text-align-last: center;
    img {
      width: 130px;
    }
    p {
      font-size: var(--text-size-bit-larger);
      color: #777;
      line-height: 36px;
      margin-top: 40px;
      line-height: 1.8;
      text-align: justify;
      text-align-last: center;
    }
  }
}
.wap2 {
  display: flex;

  .left-content {
    width: 50%;
    min-width: 600px;
    min-height: 500px;
    background: url(../../assets/images/about/about5.jpg) no-repeat center;
    background-size: cover;
  }

  .right-content {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    width: 50%;
    min-width: 600px;
    background: #e8363e;
    padding: 50px 80px;

    div {
      box-sizing: border-box;
      font-size: 16px;
      font-size: var(--text-size-normal);
      color: #fff;
      line-height: 1.8;
      text-align: justify;
    }
  }
}
.wap3 {
  padding-top: 80px;
  padding-bottom: 70px;

  .wap3-content {
    width: 1200px;
    margin: 0 auto 0;
    text-align: center;

    .main-content {
      width: 1000px;
      margin: 0 auto 0;

      div {
        text-align: justify;
        // font-size: 18px;
        font-size: var(--text-size-normal);
        color: #777;
        line-height: 2;
        margin-top: 50px;
      }
    }

    hr {
      margin-top: 70px;
      margin-bottom: 60px;
    }

    .other--content {
      font-size: 20px;
      color: #003359;
      // display: flex;
      // justify-content: space-between;
    }

    .box {
      width: 360px;
      text-align: center;

      .title {
        font-size: 22px;
        color: #333;
      }

      img {
        margin-top: 20px;
        margin-bottom: 15px;
      }

      p {
        font-size: 17px;
        color: #777;
        line-height: 32px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/aboutDetail.vue